
import { useEffect } from 'react';
import { useState } from 'react';
import { Row, Col, Card, Form, Modal } from 'react-bootstrap'
import { SharedButton } from '../../../../../sharedComponents/Button';
import { InputField } from '../../../../../sharedComponents/InputField';
import { SharedSelect } from '../../../../../sharedComponents/SharedSelect';
import Swal from 'sweetalert2';
import logo from '../../../../../Images/logo_white_web.png';
import { API_clover_buy_now_workshop_by_save_card, buy_now_workshop_cash, cardGet, clover_buy_now_workshop, generateToken, getWorkshopDiscountCodeAPI } from '../../../../../Studio-Services/Studio_Services';
import { ExpiryCheck } from '../../../../../Static_Services/Staff_Services';
import { errorAlert } from '../../../../../Static_Services/Alertmsg';



export const WorkShopBox = ({ data, workData, setLoder, setWorkData, searchReset, setSerchvalue, scheduleWorkshopList }) => {

    const [innerLoader, setInnerLoader] = useState(false);
    const [saveCards, setSaveCards] = useState([]);
    const [showCodeModel, setShowCodeModel] = useState({ visible: false });
    const [dCodeId, setDCodeId] = useState('');
    const [dCodeName, setDCodeName] = useState('');


    const [cardSaved, setCardSaved] = useState(false);
    const grandTotal = (amount, tax) => {
        const total = +amount + +tax;
        // const grand = total.toFixed(2);
        return total;
    }

    const [selectCustomer, setSelectCustomer] = useState();

    const getProductPrice = (amount, tax) => {
        if (tax === 0) {
            return 0;
        } else {
            const taxAmount = (+tax / 100) * +amount;
            return taxAmount;
        }
    }

    const calculateTax = (object) => {
        let tax = 0;
        if (object.tax1 === 'yes') {
            tax += +object.tax1_rate;
        }
        if (object.tax2 === 'yes') {
            tax += +object.tax2_rate;
        }
        return parseFloat(getProductPrice(object.price, tax)).toFixed(2);
    }

    const [userDetail, setUserDetail] = useState();

    const [payDetails, setPayDetails] = useState({ "baseAmount": 0, "discount": 0, "adj_price": 0, "tax1": 0, "tax2": 0, "total": 0 });

    useEffect(() => {
        if (JSON.parse(localStorage.getItem('st_userData'))) {
            setUserDetail(JSON.parse(localStorage.getItem('st_userData')));
        }
    }, []);


    useEffect(() => {
        if (workData?.price) {
            let pre = { ...payDetails };
            let tax1 = getProductPrice(workData?.price, workData?.tax1_rate);
            let tax2 = getProductPrice(workData?.price, workData?.tax2_rate);
            let total = grandTotal(workData?.price, calculateTax(workData));

            pre.baseAmount = workData.price;
            pre.discount = 0;
            pre.adj_price = workData.price;
            pre.tax1 = tax1;
            pre.tax2 = tax2;
            pre.total = total;

            setPayDetails(pre);
        }
    }, [workData])

    const [preData, setPreData] = useState([]);
    const [clintId, setClintId] = useState();
    const [checkOut, setCheckOut] = useState(false);
    const [cartdetail, setCartdetail] = useState();
    const [paytype, setPaytype] = useState();

    const [dcList, setDcList] = useState([]);

    useEffect(() => {
        setPreData(data);
    }, [data])


    const workshopDiscountCode = async (workshop_id, client_id) => {
        if (!workshop_id || !client_id) { return; }
        const payload = { 'workshop_id': workshop_id, 'client_id': client_id }
        try {
            setLoder(true);
            const resp = await getWorkshopDiscountCodeAPI(payload);
            if (resp?.data) {
                setDcList(resp.data);
            } else {
                setDcList([]);
            }
        } catch (er) {
            console.log("-----------", er);
        } finally {
            setLoder(false);
        }
    }

    const cartPuchase = async (data) => {
        setSelectCustomer(data);
        setClintId(data.id);
        const cld = data?.id ?? '';
        const wrd = data?.workshop_id ?? '';
        workshopDiscountCode(wrd, cld);
        preData.forEach(e => {
            if (e.data.id === data.id) {
                setCartdetail(e.data);
            }
        })

        const customerID = data?.id || '';

        setInnerLoader(true);
        if (customerID) {
            const payload = { "userid": customerID, }
            const resp = await cardGet(payload);
            if (resp) {
                setInnerLoader(false);
                setSaveCards(resp.data.data);
            }
        }
        setInnerLoader(false);

    }

    useState(() => {
        if (preData.length <= 0) {
            setClintId();
        }
    }, [preData])


    const paymodeOP = [
        {
            value: "Cash", label: "Cash"
        },
        {
            value: "POS", label: "POS"
        },
        {
            value: "Pass", label: "Pass"
        },
        {
            value: "GiftCard", label: "GiftCard"
        },
        {
            value: "Check", label: "Check"
        },
        {
            value: "Direct Debit", label: "Direct Debit"
        }
    ]

    // Payment Card Code
    const [expiryDate, setExpiryDate] = useState();

    const handleInputChange = (e) => {
        const inputValue = e.target.value;
        if (e.nativeEvent.inputType === "deleteContentBackward") {
            if (inputValue.endsWith('/')) {
                setExpiryDate(inputValue.slice(0, -1));
            } else { setExpiryDate(inputValue); }
        } else {
            if (inputValue.length === 2 && inputValue.charAt(2) !== '/') {
                setExpiryDate(inputValue + '/');
            } else if (inputValue.length === 8) { return; } else { setExpiryDate(inputValue); }
        }
    };

    const [carderror, setCarderror] = useState({ name: "", crnumber: "", dates: "", cvv: "" });
    const [cardData, setCardData] = useState({ name: "", crnumber: "", dates: "", cvv: "" });

    const CardInputChange = (e) => {
        const { name, value } = e.target;
        const cleanedValue = value.replace(/^\s+/g, '');
        setCardData((pre) => ({ ...pre, [name]: cleanedValue }));
        setCarderror((pre) => ({ ...pre, [name]: "" }));
    }


    const [error, setError] = useState({
        cardName: "",
        cardNumber: "",
        valid: "",
        cvv: "",
        mode: "",
        transactionid: "",
        notes: "",
    });

    const submitHandler = async (e) => {
        e.preventDefault();
        let isValid = 1;
        const fData = new FormData(e.target);
        const fValue = Object.fromEntries(fData.entries());

        const PayMode = fValue.mode ? fValue.mode : "";
        const transactionid = fValue.transactionid ? fValue.transactionid : "1234";
        const notes = fValue.notes ? fValue.notes : "";

        let expiry_month = '';
        let expiry_year = '';
        let expired = '';

        if (expiryDate) { expired = ExpiryCheck(expiryDate); };
        if (expired) {
            expiry_month = expired[0];
            expiry_year = expired[1];
        } else {
            setCarderror((pre) => ({ ...pre, dates: "* Valid Till is required" }));
            isValid = 2;
        }

        if (!cardData.name) { setCarderror((pre) => ({ ...pre, name: "* Card Holder Name is required" })); isValid = 3; };
        if (!cardData.crnumber) {
            setCarderror((pre) => ({ ...pre, crnumber: "* Card Number is required" }))
            isValid = 4;
        };
        if (!cardData.cvv) {
            setCarderror((pre) => ({ ...pre, cvv: "* CVV is required" }));
            isValid = 5;
        };

        if (!PayMode) { setError((pre) => ({ ...pre, mode: "*Required" })); isValid = 2 }
        if (!transactionid) { setError((pre) => ({ ...pre, transactionid: "*Required" })); isValid = 2 }
        // if (!notes) { setError((pre) => ({ ...pre, notes: "*Required" })); isValid = 2 }

        const tex1Amount = parseFloat(getProductPrice(payDetails.adj_price, workData.tax1_rate)).toFixed(2);
        const tex2Amount = parseFloat(getProductPrice(payDetails.adj_price, workData.tax2_rate)).toFixed(2);
        const finalAmount = ((parseFloat(payDetails.adj_price) + (getProductPrice(payDetails.adj_price, workData.tax1_rate) + getProductPrice(payDetails.adj_price, workData.tax2_rate))));  //grandTotal(payDetails.adj_price, calculateTax(workData));


        // @Pay ZERO Amount 

        if (finalAmount == 0) {
            setLoder(true);
            let tempObj = {};
            tempObj.amount = ((parseFloat(payDetails.adj_price) + (getProductPrice(payDetails.adj_price, workData.tax1_rate) + getProductPrice(payDetails.adj_price, workData.tax2_rate)))); // grandTotal(workData.price, +calculateTax(workData));
            tempObj.customer_id = selectCustomer.id;
            tempObj.payment_transaction_id = 'none';
            tempObj.transaction_id = '1234';
            tempObj.workshop_id = workData.workshop_id;
            tempObj.schedule_id = workData.id;
            tempObj.payment_mode = 'Online';
            tempObj.finalBaseAmount = workData?.price;
            tempObj.finalPrice = payDetails?.adj_price;
            tempObj.finalDiscount = payDetails.discount;
            tempObj.finalAdjustPrice = payDetails?.adj_price;
            tempObj.finalTax1 = tex1Amount;
            tempObj.finalTax2 = tex2Amount;
            tempObj.finalSubTotal = finalAmount;

            tempObj.discount_code_id = dCodeId;
            tempObj.discount_code_name = dCodeName;


            const resp = await buy_now_workshop_cash(tempObj);
            if (resp) {
                setLoder(false);
                e.target.reset();
                Swal.fire({
                    html: `<img src=${logo} class="img-fluid d-block mx-auto mt-5" />
                        <h4 class="title text-capitalize text-center mt-4 textWhite">
                        SUCCESS
                      </h4>
                      <p class="text-center my-4 textcolor">
                      <small class="textWhite">
                     ${resp.data.message} </small></p>
                      `,
                    showClass: {
                        popup: 'custom-dialog-container',
                    },
                    customClass: {
                        confirmButton: 'custom-button custom-button-size modalbtn',
                    },
                });
                setPaytype();
                searchReset();
                setSerchvalue();
                setCardData({ name: "", crnumber: "", dates: "", cvv: "" });
                const customerInfo = resp.data.data;
                const rowObject = workData;
                rowObject.customer_detail = customerInfo;
                rowObject.used = +rowObject.used + 1;
                setWorkData(rowObject)
            } else setLoder(false);
        } else if (transactionid && PayMode) {
            setLoder(true);
            let tempObj = {};
            tempObj.amount = ((parseFloat(payDetails.adj_price) + (getProductPrice(payDetails.adj_price, workData.tax1_rate) + getProductPrice(payDetails.adj_price, workData.tax2_rate)))); // grandTotal(workData.price, +calculateTax(workData));
            tempObj.customer_id = selectCustomer.id;
            tempObj.payment_transaction_id = notes || 'none';
            tempObj.transaction_id = transactionid;
            tempObj.workshop_id = workData.workshop_id;
            tempObj.schedule_id = workData.id;
            tempObj.payment_mode = PayMode;

            tempObj.finalBaseAmount = workData?.price;
            tempObj.finalPrice = payDetails?.adj_price;
            tempObj.finalDiscount = payDetails.discount;
            tempObj.finalAdjustPrice = payDetails?.adj_price;
            tempObj.finalTax1 = tex1Amount;
            tempObj.finalTax2 = tex2Amount;
            tempObj.finalSubTotal = finalAmount;

            tempObj.discount_code_id = dCodeId;
            tempObj.discount_code_name = dCodeName;

            const resp = await buy_now_workshop_cash(tempObj);
            if (resp) {
                setLoder(false);
                e.target.reset();
                Swal.fire({
                    html: `<img src=${logo} class="img-fluid d-block mx-auto mt-5" />
                        <h4 class="title text-capitalize text-center mt-4 textWhite">
                        SUCCESS
                      </h4>
                      <p class="text-center my-4 textcolor">
                      <small class="textWhite">
                     ${resp.data.message} </small></p>
                      `,
                    showClass: {
                        popup: 'custom-dialog-container',
                    },
                    customClass: {
                        confirmButton: 'custom-button custom-button-size modalbtn',
                    },
                });
                setPaytype();
                searchReset();
                setSerchvalue();
                const customerInfo = resp.data.data;
                const rowObject = workData;
                rowObject.customer_detail = customerInfo;
                rowObject.used = +rowObject.used + 1;
                setWorkData(rowObject)
            } else setLoder(false);
        } else if (cardData.name && cardData.crnumber && cardData.cvv && expiry_month && expiry_year) {
            setLoder(true);
            var paymentData = {
                "number": cardData.crnumber,
                "expiry_month": expiry_month,
                "expiry_year": expiry_year,
                "cvd": cardData.cvv,
                "business_id": userDetail.business_id,
                "country_code": '',
            }
            const response = await generateToken(paymentData)
            if (response) {
                let tempObj = {};
                tempObj.workshop_id = workData.workshop_id;
                tempObj.schedule_id = workData.id;
                tempObj.customer_id = selectCustomer.id;
                tempObj.amount = ((parseFloat(payDetails.adj_price) + (getProductPrice(payDetails.adj_price, workData.tax1_rate) + getProductPrice(payDetails.adj_price, workData.tax2_rate)))); // grandTotal(payDetails.adj_price, +calculateTax(workData));
                tempObj.savecard = cardSaved ? 1 : 0;
                tempObj.card_id = "";
                tempObj.token = response.data.data.token;
                tempObj.business_id = "";
                tempObj.country_code = '';

                tempObj.finalBaseAmount = workData?.price;
                tempObj.finalPrice = payDetails?.adj_price;
                tempObj.finalDiscount = payDetails.discount;
                tempObj.finalAdjustPrice = payDetails?.adj_price;
                tempObj.finalTax1 = tex1Amount;
                tempObj.finalTax2 = tex2Amount;
                tempObj.finalSubTotal = finalAmount;

                tempObj.customer_name = cardData.name;
                tempObj.number = cardData.crnumber;
                tempObj.expiry_month = expiry_month;
                tempObj.expiry_year = expiry_year;
                tempObj.cvd = cardData.cvv;

                tempObj.discount_code_id = dCodeId;
                tempObj.discount_code_name = dCodeName;


                const finalResp = await clover_buy_now_workshop(tempObj);
                if (finalResp) {
                    setLoder(false);
                    let resp = finalResp;
                    Swal.fire({
                        html: `<img src=${logo} class="img-fluid d-block mx-auto mt-5" />
                            <h4 class="title text-capitalize text-center mt-4 textWhite">
                            SUCCESS
                          </h4>
                          <p class="text-center my-4 textcolor">
                          <small class="textWhite">
                         ${resp.data.message} </small></p>
                          `,
                        showClass: {
                            popup: 'custom-dialog-container',
                        },
                        customClass: {
                            confirmButton: 'custom-button custom-button-size modalbtn',
                        },
                    });
                    setPaytype();
                    searchReset();
                    setSerchvalue();
                    scheduleWorkshopList();
                    setCardData({ name: "", crnumber: "", dates: "", cvv: "" });
                    setLoder(false);
                    const customerInfo = resp.data.data;
                    const rowObject = workData;
                    rowObject.customer_detail = customerInfo;
                    rowObject.used = +rowObject.used + 1;
                    setWorkData(rowObject)
                    // getScheduleInfo();
                } else setLoder(false);
            } else {
                setLoder(false);
            }
        }
    }

    const modeHandler = (e) => {
        const value = e.target.value;
        setError((pre) => ({ ...pre, mode: "", }));
    }
    const errorHandler = (e) => {
        const { name, value } = e.target;
        setError((pre) => ({
            ...pre,
            [name]: "",
        }));
    };


    const onChangeHandler = (e) => {
        const { name, value } = e.target;
        if (name === 'discount') {
            const discountValue = parseFloat(value) || 0;
            const baseAmount = parseFloat(workData?.price) || 0;
            if (discountValue > baseAmount) {
                errorAlert("Discount amount cannot exceed the base service fee");
                return;
            }
            if (discountValue < 0) {
                errorAlert("Discount cannot be a negative value");
                return;
            }
        }
        let cleanedValue = value.replace(/\s+/g, "");   // remove all spaces
        cleanedValue = cleanedValue.replace(/^0+/, "");
        let preData = { ...payDetails };
        preData.discount = cleanedValue;
        setPayDetails(preData);
    };



    const onApplyDiscount = (data) => {
        if (!data) return;
        setShowCodeModel({ visible: false });
        const wrAmount = Number(workData?.price || 0);
        const percentage = Number(data?.amount || 0);
        const dis = ((wrAmount * percentage) / 100).toFixed(2);
        const discountAmount = Number(dis);

        if (discountAmount > wrAmount) {
            errorAlert("Discount amount cannot exceed the base service fee");
            return;
        }
        if (discountAmount < 0) {
            errorAlert("Discount cannot be a negative value");
            return;
        }
        let preData = { ...payDetails };
        preData.discount = discountAmount;

        const adj_price = (parseFloat(workData.price) - parseFloat(discountAmount));
        const finalTax1 = getProductPrice(adj_price, workData?.tax1_rate);
        const finalTax2 = getProductPrice(adj_price, workData?.tax2_rate);
        const finalTotal = ((adj_price + ((parseFloat(finalTax1) + parseFloat(finalTax2)))));
        preData.adj_price = adj_price;
        preData.tax1 = finalTax1;
        preData.tax2 = finalTax2;
        preData.total = finalTotal;
        setPayDetails(preData);

        setDCodeId(data.discount_code_id);
        setDCodeName(data.code_name);


        Swal.fire({
            html: `<img src=${logo} class="img-fluid d-block mx-auto mt-5" />
                               <h4 class="title text-capitalize text-center mt-4 textWhite">
                                  SUCCESS
                                          </h4>
                                          <p class="text-center my-4 textcolor">
                                          <small class="textWhite">
                                          ${"Your discount has been applied successfully."} </small></p>
                                          `,
            showClass: {
                popup: 'custom-dialog-container',
            },
            customClass: {
                confirmButton: 'custom-button custom-button-size modalbtn',
            },
        });

        // Swal.fire({
        //     html: `
        //              <div>
        //               <img src="assets/gif/congratulation.gif" width="100%" />
        //               <h4 style="color:#00ff99;
        //                position: absolute;
        //               top: 68%;
        //               left:0;
        //               right:0;
        //                 font-weight:700;
        //               ">COUPON APPLIED!</h4>
        //               <p style="color:#fff;
        //               position: absolute;
        //               top: 80%;
        //               left:0;
        //               right:0;
        //               font-weight:700;
        //               ">You saved ₹${discountAmount}</p>
        //             </div>            
        //           `,
        //     background: 'none',
        //     showConfirmButton: false,
        //     timer: 3000,
        //     showClass: {
        //         popup: 'animate__animated animate__bounceIn'
        //     }
        // });
    };


    const [dCode, setDCode] = useState('');

    const handleApply = () => {
        if (!dCode) {
            errorAlert("Please enter discount code");
            return;
        }
        const found = (dcList || []).find(
            (d) =>
                d.code_name.toLowerCase().trim() ===
                dCode.toLowerCase().trim()
        );

        if (found) {
            onApplyDiscount(found);
        } else {
            errorAlert("Invalid Discount Code");
        }
    };


    const amountUpdateHandler = () => {

        let prePayDetails = { ...payDetails };
        const adj_price = (parseFloat(workData.price) - parseFloat(payDetails.discount));
        const finalTax1 = getProductPrice(adj_price, workData?.tax1_rate);
        const finalTax2 = getProductPrice(adj_price, workData?.tax2_rate);
        const finalTotal = ((adj_price + ((parseFloat(finalTax1) + parseFloat(finalTax2)))));

        prePayDetails.adj_price = adj_price;
        prePayDetails.tax1 = finalTax1;
        prePayDetails.tax2 = finalTax2;
        prePayDetails.total = finalTotal;
        setPayDetails(prePayDetails);
    };

    const checkCardHandler = (e) => {
        const { checked } = e.target;
        Swal.fire({
            text: "Confirm with the client that they agree to have their card saved on file ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
            cancelButtonText: 'NO'
        }).then((result) => {
            if (result.isConfirmed) {
                setCardSaved(true);
            } else {
                setCardSaved(false);
            }
        });
    }



    const [savedCardId, setSavedCardId] = useState({ 'cardId': '', 'isChecked': false });

    const handleRadioChange = (event) => {
        const { value } = event.target;
        let pre = { ...savedCardId };
        if (pre.isChecked) {
            pre.isChecked = false;
            pre.cardId = '';
        } else {
            pre.isChecked = true;
            pre.cardId = value;
        }
        setSavedCardId(pre);
    };


    const paymentViaSaveCard = async (card) => {
        if (!selectCustomer?.id) { errorAlert("Something went wrong"); return; }

        const tex1Amount = parseFloat(getProductPrice(payDetails.adj_price, workData.tax1_rate)).toFixed(2);
        const tex2Amount = parseFloat(getProductPrice(payDetails.adj_price, workData.tax2_rate)).toFixed(2);
        const finalAmount = ((parseFloat(payDetails.adj_price) + (getProductPrice(payDetails.adj_price, workData.tax1_rate) + getProductPrice(payDetails.adj_price, workData.tax2_rate))));


        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Pay"
        }).then(async (result) => {
            if (result.isConfirmed) {

                if (finalAmount == 0) {
                    setLoder(true);
                    let tempObj = {};
                    tempObj.amount = ((parseFloat(payDetails.adj_price) + (getProductPrice(payDetails.adj_price, workData.tax1_rate) + getProductPrice(payDetails.adj_price, workData.tax2_rate)))); // grandTotal(workData.price, +calculateTax(workData));
                    tempObj.customer_id = selectCustomer.id;
                    tempObj.payment_transaction_id = 'none';
                    tempObj.transaction_id = '1234';
                    tempObj.workshop_id = workData.workshop_id;
                    tempObj.schedule_id = workData.id;
                    tempObj.payment_mode = 'Online';
                    tempObj.finalBaseAmount = workData?.price;
                    tempObj.finalPrice = payDetails?.adj_price;
                    tempObj.finalDiscount = payDetails.discount;
                    tempObj.finalAdjustPrice = payDetails?.adj_price;
                    tempObj.finalTax1 = tex1Amount;
                    tempObj.finalTax2 = tex2Amount;
                    tempObj.finalSubTotal = finalAmount;


                    tempObj.discount_code_id = dCodeId;
                    tempObj.discount_code_name = dCodeName;

                    const resp = await buy_now_workshop_cash(tempObj);
                    if (resp) {
                        setLoder(false);
                        Swal.fire({
                            html: `<img src=${logo} class="img-fluid d-block mx-auto mt-5" />
                        <h4 class="title text-capitalize text-center mt-4 textWhite">
                        SUCCESS
                      </h4>
                      <p class="text-center my-4 textcolor">
                      <small class="textWhite">
                     ${resp.data.message} </small></p>
                      `,
                            showClass: {
                                popup: 'custom-dialog-container',
                            },
                            customClass: {
                                confirmButton: 'custom-button custom-button-size modalbtn',
                            },
                        });
                        setPaytype();
                        searchReset();
                        setSerchvalue();
                        setCardData({ name: "", crnumber: "", dates: "", cvv: "" });
                        const customerInfo = resp.data.data;
                        const rowObject = workData;
                        rowObject.customer_detail = customerInfo;
                        rowObject.used = +rowObject.used + 1;
                        setWorkData(rowObject)
                    } else setLoder(false);

                } else {


                    let payload = {};
                    payload.workshop_id = workData.workshop_id;
                    payload.schedule_id = workData.id;
                    payload.customer_id = selectCustomer.id;
                    payload.amount = ((parseFloat(payDetails.adj_price) + (getProductPrice(payDetails.adj_price, workData.tax1_rate) + getProductPrice(payDetails.adj_price, workData.tax2_rate)))); // grandTotal(payDetails.adj_price, +calculateTax(workData));

                    payload.finalBaseAmount = workData?.price;
                    payload.finalPrice = payDetails?.adj_price;
                    payload.finalDiscount = payDetails.discount;
                    payload.finalAdjustPrice = payDetails?.adj_price;
                    payload.finalTax1 = tex1Amount;
                    payload.finalTax2 = tex2Amount;
                    payload.finalSubTotal = finalAmount;

                    payload.discount_code_id = dCodeId;
                    payload.discount_code_name = dCodeName;

                    payload.savecard = 0;
                    payload.token = card.card_token;
                    payload.card_id = card.card_id;
                    payload.member_id = "";
                    payload.client_id = selectCustomer.id;
                    setLoder(true);
                    const resp = await API_clover_buy_now_workshop_by_save_card(payload);
                    if (resp) {
                        setLoder(false);
                        Swal.fire({
                            html: `
                            <img src=${logo} class="img-fluid d-block mx-auto mt-5" />
                            <h4 class="title text-capitalize text-center mt-4 textWhite">Success</h4>
                            <p class="text-center my-4 textcolor">
                            <small class="textWhite">${resp.data.message}</small>
                            </p>
                        `,
                            showClass: {
                                popup: 'custom-dialog-container',
                            },
                            customClass: {
                                confirmButton: 'custom-button custom-button-size modalbtn',
                            },
                            confirmButtonText: 'Continue',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                setPaytype();
                                searchReset();
                                setSerchvalue();
                                scheduleWorkshopList();
                                setCardData({ name: "", crnumber: "", dates: "", cvv: "" });
                                setLoder(false);
                                const customerInfo = resp.data.data;
                                const rowObject = workData;
                                rowObject.customer_detail = customerInfo;
                                rowObject.used = +rowObject.used + 1;
                                setWorkData(rowObject)
                            }
                        });
                    } else {
                        setLoder(false);
                    }
                }
            }
        });

        setLoder(false);
    }
    return (
        <>
            {!cartdetail ?
                <>
                    {innerLoader && <div class="spinner-border mt-5" role="status"></div>}
                    <Row>
                        {preData.length > 0 ? preData.map((value, index) => (
                            <Col md={4} key={index}>
                                <Card className="ServiceCardBox" key={index}>
                                    <div className="cardImg">
                                        <Card.Img variant="top" src={value.profile_img} />
                                    </div>
                                    <Card.Body>
                                        <Card.Title className='mb-0'>{value.name}</Card.Title>
                                        <small className="m-0">{value.gender ? value.gender : "No"}</small>
                                        <Card.Text>
                                            <p className="m-0">{value.email}</p>
                                        </Card.Text>
                                        <SharedButton onClick={() => cartPuchase(value.data)} title={"Purchase"} variant={"primary"} className={"btn btn-secondary text-capitalize purchasePassBtn"} />
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))
                            : ""}
                    </Row>
                    <Row>
                        <Col>
                            <SharedButton
                                className={"w-100"}
                                href={"/workshop-schedule"}
                                title={"Back"}
                                variant={"primary"}
                            />
                        </Col>
                        <Col></Col>
                    </Row>
                </>
                :
                <>
                    <Row>
                        <Col md={4}>
                            <Card className="ServiceCardBox" style={{ height: "unset", background: "#0e8543", color: "#fff", boxShadow: "0 2px 5px 0 rgba(14, 133, 66, 0.2)" }} key={cartdetail.id}>
                                <div className="cardImg">
                                    <Card.Img variant="top" src={cartdetail.profile_img} />
                                </div>
                                <Card.Body>
                                    <Card.Title className='mb-0'>{cartdetail.name}</Card.Title>
                                    <Card.Text>
                                        <p className="m-0">{cartdetail.email}</p>
                                        <p className='m-0'>{cartdetail.mobile}</p>
                                        <p className='m-0'>{cartdetail.gender ? cartdetail.gender : "No"}</p>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>


                    <h4 className="classesHeading mt-5">
                        <small> Payment Details </small>
                    </h4>
                    <Row className='col-12 mb-4'>
                        <hr />
                        <Col md={12} className='pt-3 pb-3'>
                            <Row col={12}>
                                <Col md={3}>
                                    <Row>
                                        <Col md={6}>
                                            <div className="TextDetail">
                                                <h6>Workshop Fees</h6>
                                                <span>$ {parseFloat(payDetails?.baseAmount).toFixed(2)}</span>
                                                <span style={{ float: 'right' }}>-</span>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="TextDetail">
                                                <h6>Discount</h6>
                                                <span>$ </span>
                                                <input
                                                    type="number"
                                                    name="discount"
                                                    step="0.01"
                                                    min="0"
                                                    style={{ height: '32px', width: '60%' }}
                                                    onChange={onChangeHandler}
                                                    value={payDetails.discount}
                                                    className="form-control form-control-sm"
                                                />
                                                <span style={{ float: 'right' }}> = </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={6} className='d-flex'>
                                    <Row className='w-100'>
                                        <Col md={3}>
                                            <div className="TextDetail">
                                                <h6>Adj Price</h6>
                                                <span>$ {parseFloat(payDetails?.adj_price).toFixed(2)}</span>
                                                <span style={{ float: "right" }}> + </span>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="TextDetail">
                                                <h6>Tax 1</h6>
                                                <span>$ {parseFloat(payDetails?.tax1).toFixed(2)}</span>
                                                <span style={{ float: 'right' }}>+</span>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="TextDetail">
                                                <h6>Tax 2</h6>
                                                <span>$ {parseFloat(payDetails?.tax2).toFixed(2)}</span>
                                                <span style={{ float: 'right' }}>+</span>
                                            </div>
                                        </Col>
                                        <Col md={3} className='d-flex justify-content-center'>
                                            <div className="TextDetail">
                                                <h6>Discount Code</h6>
                                                <div className="discount-box">

                                                    <div className="inputNumber" style={{ paddingRight: '10px' }}>
                                                        <input
                                                            type="text" style={{ width: '100px', height: '32px', fontSize: '12px' }}
                                                            placeholder="discount code"
                                                            value={dCode ? dCode : ''}
                                                            onChange={(item) => { setDCode(item?.target?.value); }}
                                                            className="form-control form-control-sm"
                                                        />
                                                    </div>

                                                    <button
                                                        className="discount-button"
                                                        // onClick={() => setShowCodeModel(true)}
                                                        onClick={() => { handleApply() }}
                                                    >Apply
                                                    </button>
                                                </div>
                                            </div>
                                        </Col>
                                        {/* <Col md={3}>
                                            <div className="TextDetail">
                                                <h6>Discount Code</h6>
                                                <div className="discount-box">
                                                    <button
                                                        className="discount-button"
                                                        onClick={() => setShowCodeModel({ visible: true })}
                                                    >Apply
                                                    </button>
                                                </div>
                                            </div>
                                        </Col> */}
                                    </Row>
                                </Col>
                                <Col md={3}>
                                    <Row>
                                        <Col md={6}>
                                            <div className="TextDetail">
                                                <h6>Total Fee</h6>
                                                <p>$ {parseFloat(payDetails?.total).toFixed(2)}</p>
                                            </div>
                                        </Col>
                                        <Col md={6} className='mt-3'>
                                            <button
                                                className="btn btn-blue-grad px-2 w-100"
                                                onClick={amountUpdateHandler}
                                            >
                                                Update
                                            </button>
                                        </Col>
                                    </Row>

                                </Col>

                            </Row>
                        </Col>


                        {/* <Col md={12} className='pt-3 pb-3'>
                            <Row col={12}>
                                <Col md={3}>
                                    <div className="TextDetail text-center">
                                        <h6>Workshop Fees</h6>
                                        <p>$ {workData.price}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className="TextDetail text-center">
                                        <h6>Workshop Tax 1</h6>
                                        <p>$ {parseFloat(getProductPrice(workData.price, workData.tax1_rate)).toFixed(2)}</p>
                                    </div>
                                </Col >
                                <Col md={3}>
                                    <div className="TextDetail text-center">
                                        <h6>Workshop Tax 2</h6>
                                        <p>$ {parseFloat(getProductPrice(workData.price, workData.tax2_rate)).toFixed(2)}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className="TextDetail text-center">
                                        <h6>Amount Payable</h6>
                                        <p>$ {grandTotal(workData.price, calculateTax(workData))}</p>
                                    </div>
                                </Col>
                            </Row>
                        </Col> */}
                        <hr />
                    </Row>
                    {checkOut ?
                        <Row md={12} className='mt-4 mb-4'>
                            <Col md={12}><h4>Credit card / Debit card</h4></Col>
                            <Col md={12}>
                                <p>Payment Mode</p>
                                <Row md={12} style={{ justifyContent: "center" }}>
                                    <Col md={3}>
                                        <button type='button' onClick={() => setPaytype(3)} className={paytype === 3 ? 'ownCartBtn ownCardBtnActive' : 'ownCartBtn'}>Card On File</button>
                                    </Col>
                                    <Col md={3}>
                                        <button type='button' onClick={() => setPaytype(1)} className={paytype === 1 ? 'ownCartBtn ownCardBtnActive' : 'ownCartBtn'}>Other</button>
                                    </Col>
                                    <Col md={3}>
                                        <button type='button' onClick={() => setPaytype(2)} className={paytype === 2 ? 'ownCartBtn ownCardBtnActive' : 'ownCartBtn'}>Card</button>
                                    </Col>
                                </Row>

                                <Row className='mt-5 col-12' style={{ justifyContent: "center" }}>
                                    <Form autoComplete='off' onSubmit={submitHandler}>
                                        {paytype === 1 ?
                                            <>
                                                <Row>
                                                    <Col>
                                                        <SharedSelect
                                                            name={"mode"}
                                                            lable={"Payment Mode"}
                                                            error={error.mode}
                                                            onChange={modeHandler}
                                                            options={paymodeOP}
                                                        />
                                                    </Col>
                                                    <Col>
                                                        <InputField
                                                            type={"text"}
                                                            name={"transactionid"}
                                                            error={error.transactionid}
                                                            lable={"Transaction ID"}
                                                            onChange={errorHandler}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <InputField
                                                            type={"text"}
                                                            name={"notes"}
                                                            error={error.notes}
                                                            lable={"Notes"}
                                                            onChange={errorHandler}
                                                        />
                                                    </Col>
                                                </Row>
                                            </>
                                            : ""}
                                        {paytype === 2 ?
                                            <>
                                                <Row col={12}>
                                                    {parseFloat(payDetails?.total).toFixed(2) > 0 &&
                                                        <Col md={12} >
                                                            <div className="d-flex" style={{ justifyContent: 'right', alignItems: 'center' }}>
                                                                <h5>Save Card : </h5>
                                                                <span style={{ marginLeft: '10px', cursor: 'pointer' }}>
                                                                    <input type="checkbox" name="saveCard" className="ownCheck" onChange={checkCardHandler} checked={cardSaved} style={{ cursor: 'pointer' }} />
                                                                </span>
                                                            </div>
                                                        </Col>
                                                    }
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <p className="brand-color3 text-left font-14 mb-2"> Name On Card </p>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                name='name'
                                                                placeholder="Sophie Joe"
                                                                value={cardData.name}
                                                                onChange={CardInputChange}
                                                            />
                                                            <small className="text-danger">{carderror.name}</small>
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group client-buy-input-cardno">
                                                            <p className="brand-color3 text-left font-14 mb-2"> Card Number </p>
                                                            <input
                                                                type="text"
                                                                autoComplete="off"
                                                                className="form-control"
                                                                placeholder="4121 4411 3131 8554"
                                                                name='crnumber'
                                                                value={cardData.crnumber}
                                                                onChange={CardInputChange}
                                                                maxLength={19}
                                                            />
                                                            <small className="text-danger">{carderror.crnumber}</small>
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <p className="brand-color3 text-left font-14 mb-2"> Valid Till </p>
                                                            <input
                                                                type="text"
                                                                name={'dates'}
                                                                className="form-control"
                                                                placeholder="MM/YYYY"
                                                                value={expiryDate}
                                                                onChange={handleInputChange}
                                                                pattern="^[0-9]{2}/[0-9]{4}"
                                                                autoComplete="new-password"
                                                                lable={"Valid Through"}
                                                            />
                                                            <small className="text-danger">{carderror.dates}</small>
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="form-group">
                                                            <p className="brand-color3 text-left font-14 mb-2"> CVV </p>
                                                            <input
                                                                type="password"
                                                                autoComplete="off"
                                                                className="form-control"
                                                                placeholder="eg. 201"
                                                                name='cvv'
                                                                value={cardData.cvv}
                                                                onChange={CardInputChange}
                                                                maxLength={3}
                                                            />
                                                            <small className="text-danger">{carderror.cvv}</small>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </>
                                            : ""}


                                        {(paytype === 1 || paytype === 2) &&
                                            <Row md={12} className='mt-3 justify-content-center'>
                                                <Col md={6}>
                                                    <SharedButton
                                                        className={"w-100"}
                                                        href={"/workshop-schedule"}
                                                        title={"Back"}
                                                        variant={"primary"}
                                                    />
                                                </Col>
                                                <Col md={6}>
                                                    <SharedButton
                                                        className={"w-100"}
                                                        type={"submit"}
                                                        title={"Proceed To Pay"}
                                                        variant={"primary"}
                                                    />
                                                </Col>
                                            </Row>
                                        }

                                        {paytype === 3 ?
                                            <>
                                                <Row >
                                                    <div className="card-details" >
                                                        <h5 className="payment-head font-arialrouded text-capitalize pb-2">Saved Cards</h5>
                                                        <div>
                                                            {saveCards && saveCards.length > 0 ?
                                                                <div className="row m-0 p-0">
                                                                    {saveCards.map((cardsave) => (
                                                                        <div className='col-md-4 p-2  mb-3'>
                                                                            <div className="row mx-0 payment-history-box white-bg border-radius6 box-shadow1 p-3 ">
                                                                                <div className="col-2 pl-0">
                                                                                    {(cardsave.card_type == 'VISA' || cardsave.card_type == 'visa') && <img src="assets/images/visa_card.png" className="img-fluid" />}
                                                                                    {cardsave.card_type == 'MC' && <img src="assets/images/master_card.png" className="img-fluid" />}
                                                                                    {cardsave.card_type == 'AM' && <img src="assets/images/american_express.png" className="img-fluid" />}
                                                                                </div>
                                                                                <div className="col-8">
                                                                                    <p className="mb-0 font-14 font-w-500 dark-color"> {cardsave.number} </p>
                                                                                    <h5 className="mb-0 font-12 dark-color mt-2">Valid Till(MM/YY) </h5>
                                                                                    <p className="mb-0 font-12 dark-color"> {cardsave.expiry_month}  /
                                                                                        {cardsave.expiry_year} </p>
                                                                                </div>
                                                                                <div className="col-2 text-right">
                                                                                    <input
                                                                                        style={{ background: savedCardId?.cardId === cardsave.card_id ? '#0075ff' : '', borderRadius: '10px' }}
                                                                                        type="radio"
                                                                                        name="pass_radio"
                                                                                        id={cardsave.card_id}
                                                                                        className="pass_input_checkbox form-control"
                                                                                        value={cardsave.card_id}
                                                                                        checked={savedCardId?.cardId === cardsave.card_id && savedCardId.isChecked}
                                                                                        onClick={handleRadioChange}
                                                                                    />
                                                                                </div>
                                                                                {savedCardId?.cardId == cardsave.card_id ?
                                                                                    <form autoComplete="off">
                                                                                        <div className="text-center d-flex flex-wrap mt-4" style={{
                                                                                            justifyContent: 'center',
                                                                                            alignItems: 'center'
                                                                                        }}>
                                                                                            <button class="btn btn-brandbluegrad d-block w-50" type="button"
                                                                                                onClick={() => paymentViaSaveCard(cardsave)}
                                                                                            >Submit</button >
                                                                                        </div >
                                                                                    </form >
                                                                                    : ''}
                                                                            </div >
                                                                        </div>
                                                                    ))}
                                                                </div >
                                                                :
                                                                !innerLoader &&
                                                                <p class="text-center"> No Record Found</p >
                                                            }
                                                        </div >
                                                    </div >
                                                </Row >
                                            </>
                                            : ""}
                                    </Form>
                                </Row>
                            </Col>
                        </Row>
                        :
                        <>
                            <Row>
                                <Col>
                                    <SharedButton
                                        className={"w-100"}
                                        href={"/workshop-schedule"}
                                        title={"Back"}
                                        variant={"primary"}
                                    />
                                </Col>
                                <Col>
                                    <SharedButton
                                        className={"w-100"}
                                        onClick={() => setCheckOut(true)}
                                        title={"Check Out"}
                                        variant={"primary"}
                                    />
                                </Col>
                                <Col></Col>
                            </Row>
                        </>
                    }



                </>
            }

            <Modal
                show={showCodeModel.visible}
                onHide={() => { setShowCodeModel({ visible: false }) }}
                backdrop="static"
                centered
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Coupons Codes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {dcList?.length > 0 ?
                        (dcList ?? []).map((item, index) => (
                            <div className="row discount_model_row" key={index}>
                                <div className="col-md-9 m-auto">
                                    <p className="m-0 p-0"> {item?.code_name}</p>
                                </div>
                                <div className="col-md-3  m-auto model_button_box">
                                    <button
                                        className="discount-button"
                                        onClick={() => { onApplyDiscount(item) }}
                                    >Apply</button>
                                </div>
                            </div>
                        ))
                        :
                        <div className="row discount_model_row">
                            <div className="col-md-12 discount-box">
                                <p className="m-0 p-0"> No Coupon Available</p>
                            </div>
                        </div>
                    }
                </Modal.Body>
            </Modal >

        </>
    )
}
